import React, { Component } from 'react'
import Input from '@material-ui/core/Input'
import InputAdornment from '@material-ui/core/InputAdornment'
import Icon from '@material-ui/core/Icon'
import T from 'prop-types'
import Psfs from 'lib/psfs/Psfs'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'

class SearchBlock extends Component {
  static contextTypes = {
    router: T.shape({
      history: T.shape({
        push: T.func.isRequired,
      }).isRequired,
    }).isRequired,
  }

  constructor(props) {
    super(props)
    this.searchTimer = null
    this.inputRef = React.createRef()
    this.state = {
      searchValue: '',
      isSearchOpened: false,
    }
  }

  UNSAFE_componentWillMount() {
    this.historyPush = this.context.router.history.push
    this.location = this.context.router.route.location
    this.initPsfs()

    if (this.psfs.searchObj.value) {
      this.setState({
        searchValue: this.psfs.searchObj.value,
      })
    }
  }

  initPsfs() {
    this.psfs = Psfs.create(this.location.pathname)
  }

  onSearchChange = e => {
    const { storePsfs, setPsfs } = this.props
    this.setState({ searchValue: e.target.value })
    clearTimeout(this.searchTimer)
    this.searchTimer = setTimeout(
      // eslint-disable-next-line @typescript-eslint/no-implied-eval
      this.historyPush,
      2000,
      this.psfs.createSearch(e.target.value).path,
    )

    if (storePsfs) {
      this.psfs._filters = storePsfs._filters
      setPsfs(this.psfs)
    }
  }

  onSearchEnterDown = e => {
    if (e.keyCode === 13) {
      const { storePsfs, setPsfs } = this.props
      clearTimeout(this.searchTimer)
      this.historyPush(this.psfs.createSearch(e.target.value).path)
      if (storePsfs) {
        this.psfs._filters = storePsfs._filters
        setPsfs(this.psfs)
      }
    }
  }

  onClear = () => {
    const { storePsfs, setPsfs } = this.props
    if (this.state.searchValue) {
      this.setState({ searchValue: '' })
      clearTimeout(this.searchTimer)
      this.initPsfs()
      this.psfs.searchObj.clearSearch()
      this.historyPush(this.psfs.path)

      if (storePsfs) {
        setPsfs(this.psfs)
      }
    }
  }

  onSearchFocus = () => {
    if (ifWindowWidthLessThan(992)) {
      this.setState({ isSearchOpened: true })
    }
  }

  onSearchBlur = () => {
    if (ifWindowWidthLessThan(992)) {
      this.setState({ isSearchOpened: false })
    }
  }

  onCloseMobileSearch = e => {
    e.preventDefault()
    const hasSearchValue = !!this.state.searchValue

    if (hasSearchValue) {
      this.onClear()
    }

    if (this.inputRef.current) {
      this.inputRef.current.blur()
    }

    this.setState({ isSearchOpened: false })
  }

  onSearchIconClick = e => {
    e.preventDefault()

    if (ifWindowWidthLessThan(992)) {
      this.setState({ isSearchOpened: true })
    }

    if (this.inputRef.current) {
      this.inputRef.current.focus()
    }
  }

  render() {
    const { className, placeholder = '' } = this.props
    const endAdorment = {}
    const isMobileResolution = ifWindowWidthLessThan(992)
    const showMobileCloseButton =
      isMobileResolution && this.state.isSearchOpened

    if (this.state.searchValue || showMobileCloseButton) {
      endAdorment.endAdornment = (
        <InputAdornment className="clear-search" position="end">
          {this.state.searchValue && (
            <Icon color="disabled" onClick={this.onClear}>
              clear
            </Icon>
          )}
          {showMobileCloseButton && (
            <Icon color="disabled" onMouseDown={this.onCloseMobileSearch}>
              close
            </Icon>
          )}
        </InputAdornment>
      )
    }

    return (
      <div className={`search ${className}`}>
        <Input
          inputRef={this.inputRef}
          placeholder={placeholder}
          onChange={this.onSearchChange}
          onKeyDown={this.onSearchEnterDown}
          onFocus={this.onSearchFocus}
          onBlur={this.onSearchBlur}
          startAdornment={
            <InputAdornment className="searching" position="start">
              <Icon onMouseDown={this.onSearchIconClick}>search</Icon>
            </InputAdornment>
          }
          {...endAdorment}
          value={this.state.searchValue}
        />
      </div>
    )
  }
}

export default SearchBlock
